class BambooStockFilter extends HTMLElement {
  async connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    await customElements.whenDefined('facet-filters-form');
    this.select = this.querySelector('select');
    this.clearButton = this.querySelector('button');
    this.options = Array.from(this.select.options).map(option => option.textContent);
    this.querySelector('.bamboo-stock-controls').hidden = false;
    this.select.addEventListener('change', event => this.change(event));
    this.clearButton.addEventListener('click', event => {
      this.select.value = '';
      this.change(event);
    });
    const params = new URLSearchParams(location.search);
    const legacy = params.has('filter.v.availability');
    const normalized = this.prepare(params.toString());
    if (legacy) {
      history.replaceState({ searchParams: normalized }, '', location.pathname + (normalized ? '?' + normalized : '') + location.hash);
      FacetFiltersForm.searchParamsInitial = normalized;
      FacetFiltersForm.renderPage(normalized, null, false);
    } else {
      this.apply();
    }
  }

  prepare(searchParams, event) {
    const params = new URLSearchParams(searchParams);
    let selected = params.get('stock');
    if (selected === null && params.has('filter.v.availability')) {
      const values = params.getAll('filter.v.availability');
      selected = values.length === 1 ? values[0] : '';
    }
    const clearAll = event?.currentTarget?.matches?.('.active-facets__button-remove, .mobile-facets__clear');
    if (selected === null) selected = event && !clearAll ? this.select.value : '';
    if (selected !== '1' && selected !== '0') selected = '';
    this.select.value = selected;
    params.delete('filter.v.availability');
    params.delete('page');
    if (selected) params.set('stock', selected);
    else params.delete('stock');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) params.set('preview_theme_id', preview);
    return params.toString();
  }

  change(event) {
    const params = new URLSearchParams(location.search);
    if (this.select.value) params.set('stock', this.select.value);
    else params.delete('stock');
    const searchParams = this.prepare(params.toString(), event);
    FacetFiltersForm.searchParamsPrev = searchParams;
    FacetFiltersForm.updateURLHash(searchParams);
    this.apply();
  }

  apply() {
    const items = Array.from(document.querySelectorAll('#product-grid [data-bamboo-stock-item]'));
    const selected = this.select.value;
    const available = items.filter(item => item.dataset.available === 'true').length;
    let shown = 0;
    for (const item of items) {
      const matches = !selected || (selected === '1') === (item.dataset.available === 'true');
      item.hidden = !matches;
      if (matches) shown++;
    }
    const counts = [items.length, available, items.length - available];
    Array.from(this.select.options).forEach((option, index) => {
      option.textContent = this.options[index] + ' (' + counts[index] + ')';
    });
    this.clearButton.hidden = !selected;
    this.querySelector('.bamboo-stock-empty').hidden = !(selected && shown === 0 && items.length > 0);
    const text = this.dataset.countTemplate.replace('__shown__', shown).replace('__total__', this.dataset.total);
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(counter => { counter.textContent = text; });
  }
}
if (!customElements.get('bamboo-stock-filter')) customElements.define('bamboo-stock-filter', BambooStockFilter);
